module.exports = __webpack_public_path__ + "img/icon_map_53_on_110.ee106fc5.png";